// Local-timezone date helpers. CRITICAL: usar para filtros e form inputs (type="date"),
// pois `Date.toISOString()` retorna UTC e quebra o filtro "Hoje" à noite no Brasil (UTC-3).

/** Returns YYYY-MM-DD for the LOCAL timezone (not UTC). */
export const localDateISO = (d = new Date()) => {
  const y = d.getFullYear();
  const m = String(d.getMonth() + 1).padStart(2, '0');
  const day = String(d.getDate()).padStart(2, '0');
  return `${y}-${m}-${day}`;
};

/** Returns YYYY-MM-DD for the first day of the current local month. */
export const localFirstOfMonthISO = (d = new Date()) => {
  const y = d.getFullYear();
  const m = String(d.getMonth() + 1).padStart(2, '0');
  return `${y}-${m}-01`;
};

/** Returns YYYY-MM-DD for N days ago in LOCAL timezone. */
export const localDaysAgoISO = (n) => {
  const d = new Date();
  d.setDate(d.getDate() - n);
  return localDateISO(d);
};
